import { useRouter } from "next/router";
import { ErrorBoundaryProps } from "./ErrorBoundaryProps";
import ErrorLayout from "./ErrorLayout";
import ErrorIndicator from "./ErrorIndicator";
import Button from "components/elements/Button/Button";

export default function Project403AccessError({ onReset }: ErrorBoundaryProps) {
  const router = useRouter();

  async function onClickReturn() {
    await router.replace("/");
    onReset?.();
  }

  return (
    <ErrorLayout>
      <h1 className="flex items-center text-5xl font-thin text-primary">
        <ErrorIndicator />
        You don&apos;t have permission to access this project.
      </h1>
      <p className="text-lg font-thin text-primary">
        If you need access to this project, please contact one of the
        project&apos;s administrators.
      </p>
      <Button type="button" theme="primary-solid" onClick={onClickReturn}>
        Return to projects list
      </Button>
    </ErrorLayout>
  );
}
